import(/* webpackMode: "eager", webpackExports: ["StakingProjectClient"] */ "/codebuild/output/src1537574305/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/staking/[id]/StakingProjectClient.tsx");
